var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    !_vm.emojiType
      ? _c(
          "span",
          [
            _c("vue-slider", {
              class: { "slider-disabled": _vm.disabled },
              attrs: {
                min: _vm.minValue,
                max: _vm.maxValue,
                tooltip: "none",
                dotStyle: _vm.dotStyle,
                railStyle: _vm.railStyle,
                disabled: _vm.disabled,
                marks: _vm.marks
              },
              on: {
                "drag-end": function($event) {
                  !_vm.disabled && !_vm.avoidSaveOnChange
                    ? (_vm.showConfirmDialog = true)
                    : null
                }
              },
              nativeOn: {
                click: function($event) {
                  !_vm.disabled && !_vm.avoidSaveOnChange
                    ? (_vm.showConfirmDialog = true)
                    : null
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function(ref) {
                      var value = ref.value
                      return [
                        _c(
                          "div",
                          {
                            class: [
                              "vue-slider-mark-label",
                              {
                                "vue-slider-mark-label-last":
                                  value == _vm.maxValue
                              }
                            ]
                          },
                          [_vm._v(_vm._s(_vm.marks[value].label))]
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                676413667
              ),
              model: {
                value: _vm.localValue,
                callback: function($$v) {
                  _vm.localValue = $$v
                },
                expression: "localValue"
              }
            }),
            _vm._v(" "),
            _c("base-dialog", {
              attrs: {
                okBtnText: _vm.$t("yes"),
                cancelBtnText: _vm.$t("no"),
                okFn: function() {
                  _vm.save()
                },
                cancelFn: function() {
                  _vm.showConfirmDialog = false
                  _vm.localValue = _vm.initialValue
                },
                content: _vm.$t("confirm-save-slider")
              },
              model: {
                value: _vm.showConfirmDialog,
                callback: function($$v) {
                  _vm.showConfirmDialog = $$v
                },
                expression: "showConfirmDialog"
              }
            })
          ],
          1
        )
      : _c(
          "span",
          [
            _c("emoji-input", {
              on: {
                change: function() {
                  _vm.save()
                }
              },
              model: {
                value: _vm.localValue,
                callback: function($$v) {
                  _vm.localValue = $$v
                },
                expression: "localValue"
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "d-flex justify-content-between emoji-input-labels"
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.minLabel))]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.maxLabel))])
              ]
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36b217ef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36b217ef","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ClinicHistoryVariableSlider.vue
// module id = 2600
// module chunks = 29 32 34 37 38 141